import { CommonModule } from '@angular/common';
import { Component, NgModule } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { DxFormModule } from 'devextreme-angular/ui/form';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxLoadIndicatorModule } from 'devextreme-angular/ui/load-indicator';
import notify from 'devextreme/ui/notify';
import { AuthService } from '../../services';
import { DxTextBoxModule } from 'devextreme-angular';
import { UserLoginRequest } from '../../../classes/infrastructure/request_response/userloginrequest';
import { isNullOrUndefined } from '../../../../tools';
import { UIUtils } from '../../../services/uiutils.service';
import { ServerCommunicatorService } from '../../../services/server-communicator.service';
import { AppStateManageService } from '../../../services/app-state-manage.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../services/language.service';


@Component({
  selector: 'app-otp-form',
  templateUrl: './otp-form.component.html',
  styleUrls: ['./otp-form.component.scss'],
  standalone: false
})
export class OTPFormComponent {
  loading = false;
  
  formData: any = { otp: '', EmailID: ''};
  useSubmitBehavior: boolean = true
  isResendOtpDisabled: boolean = false;
  ResendOtpTimer: number = 60; // Initial timer value

  constructor(private authService: AuthService, private router: Router, private uiUtils: UIUtils,private servercommunicator: ServerCommunicatorService,private appStateManage: AppStateManageService,public langService: LanguageService,
        private translate: TranslateService
  ) { }

   async ngOnInit() {
    this.formData.EmailID =  await this.appStateManage.StorageKey.getItem('Email')
    this.startResendOtpTimer();
  }
  
  
get isMr() {
  return this.langService.currentLang === 'mr';
}  
  passwordMode = 'password';
  
  togglePasswordVisibility = () => {
    this.passwordMode = this.passwordMode === 'text' ? 'password' : 'text';
  };
  
  isDisableInput: boolean = false;
  

  // old implementation of verify otp
//   verifyotp = async () => {
//     this.formData.EmailID =  await this.appStateManage.StorageKey.getItem('Email')
//     let body = {
//       otp: this.formData.OTP,
//       email_id: this.formData.EmailID,
//     }
//     if (this.formData.OTP == '') {
//       // await this.uiUtils.showErrorMessage('', 'Enter OTP');
//       await this.uiUtils.showErrorMessage(
//   this.isMr ? 'त्रुटी' : 'Error',
//   this.isMr ? 'ओटीपी टाका' : 'Enter OTP'
// );
//       return
//     }
//     // ---------------------using new mqtt service --------------------
//     const response = await this.servercommunicator.VerifyOTP(
//       'verifyuserotp',
//       body
//     );
//     if (!response.successful) {
//       await this.uiUtils.showErrorMessage('Error', response.message);
//       return
//     }
//     else {
//       // await this.uiUtils.showSuccessToster('OTP Verified Successfuly');
//       await this.uiUtils.showSuccessToster(
//   this.isMr
//     ? 'ओटीपी यशस्वीरित्या पडताळला'
//     : 'OTP verified successfully'
// );
//       this.appStateManage.StorageKey.setItem('OTP',this.formData.OTP)
//     }
//     this.router.navigate(['/create-new-password']);
//   }

// new implementation of verify otp with loading state and better error handling
verifyotp = async () => {
  // ✅ Validate first, before fetching email from storage
  if (this.formData.OTP.trim() === '') {
    await this.uiUtils.showErrorMessage(
      this.isMr ? 'त्रुटी' : 'Error',
      this.isMr ? 'ओटीपी टाका' : 'Enter OTP'
    );
    return;
  }

  this.loading = true; // ✅ show loader
  try {
    this.formData.EmailID = await this.appStateManage.StorageKey.getItem('Email');

    const body = {
      otp: this.formData.OTP,
      email_id: this.formData.EmailID,
    };

    const response = await this.servercommunicator.VerifyOTP('verifyuserotp', body);

    if (!response.successful) {
      await this.uiUtils.showErrorMessage('Error', response.message);
      return;
    }

    await this.uiUtils.showSuccessToster(
      this.isMr ? 'ओटीपी यशस्वीरित्या पडताळला' : 'OTP verified successfully'
    );

    this.appStateManage.StorageKey.setItem('OTP', this.formData.OTP);
    await this.router.navigate(['/create-new-password']); // ✅ await navigation

  } finally {
    this.loading = false; // ✅ always reset loader
  }
};

  
  ResendOtp = async () => {
    this.formData.EmailID =  await this.appStateManage.StorageKey.getItem('Email')
    if (this.isResendOtpDisabled) return
    this.formData.OTP = '';
    let body = {
       email_id:  this.formData.EmailID,
      }
      this.isResendOtpDisabled = true;
    // ---------------------using new mqtt service --------------------
    const response = await this.servercommunicator.FetchRequestForForgotPassword(
      'generateuserotp',
      body
    );
    if (!response.successful) {
      this.isResendOtpDisabled = false;
      await this.uiUtils.showSuccessToster(response.message);
      return
    }
    await this.uiUtils.showSuccessToster(
  this.isMr
    ? 'कृपया तुमचा ईमेल तपासा, ओटीपी पुन्हा पाठवण्यात आला आहे'
    : 'Please check your email, OTP has been resent'
);
  }

   startResendOtpTimer = async () => {
    this.isResendOtpDisabled = true;
    this.ResendOtpTimer = 60; // Reset the timer

    const interval = setInterval(() => {
      this.ResendOtpTimer--;

      if (this.ResendOtpTimer <= 0) {
        clearInterval(interval); // Clear the interval when the timer ends
        this.isResendOtpDisabled = false; // Re-enable the link
      }
    }, 1000); // Decrement every second
  }

  NavigateForgotPassword = () => {
    this.router.navigate(['forgot-password']);
  }
}
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DxFormModule,
    DxLoadIndicatorModule,
    DxButtonModule,
    DxFormModule,
    DxTextBoxModule,
    DxButtonModule,
  ],
  declarations: [OTPFormComponent],
  exports: [OTPFormComponent]
})
export class OTPFormModule { }
